module.exports = __webpack_public_path__ + "img/dog-icon.7b55ce49.svg";